"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _RangeSlider = _interopRequireDefault(require("./RangeSlider.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SliderWrapper = _styledComponents.default.div.withConfig({
  displayName: "RangeSlider__SliderWrapper",
  componentId: "sc-wvdl8u-0"
})(["display:flex;align-items:center;flex-direction:row;cursor:pointer;width:100%;height:", ";"], function (_ref) {
  var theme = _ref.theme,
    bigPointsSlider = _ref.bigPointsSlider;
  return bigPointsSlider ? theme.space.normal : theme.space.semiLarge;
});
var SliderContainer = _styledComponents.default.div.withConfig({
  displayName: "RangeSlider__SliderContainer",
  componentId: "sc-wvdl8u-1"
})([""]);
var PlaceholderText = _styledComponents.default.div.withConfig({
  displayName: "RangeSlider__PlaceholderText",
  componentId: "sc-wvdl8u-2"
})(["padding:8px 0px;"]);
var Slider = _styledComponents.default.input.withConfig({
  displayName: "RangeSlider__Slider",
  componentId: "sc-wvdl8u-3"
})(["appearance:none;height:", ";outline:none;width:100%;background:-webkit-gradient( linear,left top,right top,color-stop( ", ",", " ),color-stop( ", ",", " ) );margin:0 auto;::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;height:", ";width:", ";border:1px solid ", ";border-radius:", ";background:", ";cursor:grab;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.micro;
}, function (_ref3) {
  var value = _ref3.value,
    min = _ref3.min,
    max = _ref3.max;
  var val = (value - min) / (max - min);
  return Number.isInteger(val) ? val : 0;
}, function (_ref4) {
  var theme = _ref4.theme,
    color = _ref4.color;
  return theme.colors[color];
}, function (_ref5) {
  var value = _ref5.value,
    min = _ref5.min,
    max = _ref5.max;
  var val = (value - min) / (max - min);
  return Number.isInteger(val) ? val : 0;
}, function (_ref6) {
  var theme = _ref6.theme,
    emptyAreaColor = _ref6.emptyAreaColor;
  return theme.colors[emptyAreaColor];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.normal;
}, function (_ref9) {
  var theme = _ref9.theme,
    color = _ref9.color;
  return theme.colors[color];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius.XLarge;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.backgroundColor.default;
});
var LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "RangeSlider__LabelWrapper",
  componentId: "sc-wvdl8u-4"
})(["display:flex;justify-content:space-between;"]);
var RangeSlider = function RangeSlider(_ref12) {
  var theme = _ref12.theme,
    onChange = _ref12.onChange,
    minValue = _ref12.minValue,
    maxValue = _ref12.maxValue,
    defaultValue = _ref12.defaultValue,
    accessible = _ref12.accessible,
    customProperties = _ref12.customProperties,
    color = _ref12.color,
    emptyAreaColor = _ref12.emptyAreaColor,
    _ref12$filterData = _ref12.filterData,
    filterData = _ref12$filterData === void 0 ? {} : _ref12$filterData,
    hideHeaderTitle = _ref12.hideHeaderTitle,
    displayBottomSliderLabel = _ref12.displayBottomSliderLabel,
    _ref12$currency = _ref12.currency,
    currency = _ref12$currency === void 0 ? '' : _ref12$currency;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    sliderValue = _useState2[0],
    setSliderValue = _useState2[1];
  var onChangeHandler = function onChangeHandler(value) {
    onChange(value.target.value);
  };
  var sliderHandler = function sliderHandler(value) {
    setSliderValue(value.target.value);
  };
  (0, _react.useEffect)(function () {
    setSliderValue(defaultValue);
  }, [defaultValue]);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(SliderContainer, null, !hideHeaderTitle && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PlaceholderText, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      bold: true
    }, filterData.placeholderText)), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "greyDarker",
      type: "sub"
    }, filterData.filterLabel, " ", filterData.maxValue, " ", filterData.type)), /*#__PURE__*/_react.default.createElement(SliderWrapper, (0, _extends2.default)({
      bigPointsSlider: true,
      theme: themeContext
    }, customProperties), /*#__PURE__*/_react.default.createElement(Slider, {
      type: "range",
      min: minValue,
      max: maxValue,
      value: sliderValue,
      tabIndex: tabIndex,
      color: color,
      emptyAreaColor: emptyAreaColor,
      onChange: function onChange(val) {
        sliderHandler(val);
        onChangeHandler(val);
      },
      onMouseUp: function onMouseUp(val) {
        return onChangeHandler(val);
      },
      onTouchEnd: function onTouchEnd(val) {
        return onChangeHandler(val);
      }
    })), displayBottomSliderLabel && /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "greyDarker",
      type: "sub"
    }, filterData.minimum.replace('{0}', _utilities.default.formatAmount(minValue, 0, currency))), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "greyDarker",
      type: "sub"
    }, filterData.maximum.replace('{0}', _utilities.default.formatAmount(maxValue, 0, currency)))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
RangeSlider.propTypes = _RangeSlider.default.PropTypes;
RangeSlider.defaultProps = _RangeSlider.default.DefaultProps;
var _default = RangeSlider;
exports.default = _default;